/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { ColumnDoubleClickingBehavior } from '@bingads-webui/projection-grid-column-resize';
import { localPreferenceService } from './local-preference-service';
import { campaignGridColumnResizePlugin } from './plugins';
import headerTemplate from './header.pug';
import './header.less';

const FILE_VERSION = 1;

export const getPGridColumnResizePlugin = ({
  gridName,
  preferenceService,
}) => {
  const preferenceSrv = preferenceService || localPreferenceService;
  const preferenceKey = `${gridName}-ColumnResizePlugin`;
  const debouncedSaveToPreference = _.debounce(preferenceSrv.setAtUserLevel, 500);

  let cache = null;
  let manuallySetLastColumnWidth = null;

  // when saving data, try to keep existing data
  // for example, when CPA columns are expanded, columns
  // only contains CPA sub columns, but cache may contains
  // CPA column data. by this way, we can restore CPA column
  // width after collpase CPA column
  const saveToStore = (columns, widthState) => {
    if (columns) {
      if (cache === null) {
        cache = {};
      }
      columns.forEach((c) => {
        const col = {};
        if (_.isNumber(c.width)) {
          col.width = c.width;
        }
        if (_.isNumber(c.left)) {
          col.left = c.left;
        }
        if (c.name) {
          cache[c.name] = col;
        }
      });

      if (widthState && _.isNumber(widthState.manuallySetLastColumnWidth)) {
        // eslint-disable-next-line prefer-destructuring
        manuallySetLastColumnWidth = widthState.manuallySetLastColumnWidth;
      }

      // save to preference service
      debouncedSaveToPreference({
        Name: preferenceKey,
        Data: { version: FILE_VERSION, columns: cache, manuallySetLastColumnWidth },
      });
    }
  };

  const loadFromStore = (state) => {
    // load data
    if (cache === null) {
      const { Data = {} } = preferenceSrv.findByNameAtUserLevel(preferenceKey) || {};
      const { version, columns, manuallySetLastColumnWidth: mslcw } = Data;
      // discard the data if versions dismatch
      if (version === FILE_VERSION) {
        cache = columns;

        if (_.isNumber(mslcw)) {
          manuallySetLastColumnWidth = mslcw;
        }
      }
    }

    const loadedColumns = [];
    const stateColumns = state.columnGroup && state.columnGroup.leafColumns
      ? state.columnGroup.leafColumns
      : state.columns;
    if (cache && stateColumns) {
      stateColumns.forEach((c) => {
        const col = { name: c.name };
        const { width, left } = cache[c.name] || {};
        if (_.isNumber(width)) {
          col.width = width;
        }
        if (_.isNumber(left)) {
          col.left = left;
        }
        loadedColumns.push(col);
      });
    }

    return [loadedColumns, manuallySetLastColumnWidth];
  };

  // add grabber to table header cell, also add a class
  // 'resizable-column-header' to <th>
  const renderGrabber = (cell, isDraggingCurCol) => _.defaults({
    html: headerTemplate({
      val: cell.html,
      dragging: isDraggingCurCol,
    }),
    classes: ['resizable-column-header', ...cell.classes],
  }, cell);

  return {
    plugin: campaignGridColumnResizePlugin,
    config: {
      isSaveEnabled: true,
      doubleClickingBehavior: ColumnDoubleClickingBehavior.resizeToMinWidth,
      saveToStore,
      loadFromStore,
      renderGrabber,
    },
  };
};
